import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DTypeFormCodebarScannerField } from '@grupo-constant/next-dtype/form';
import { DTypeViewableCol } from '@grupo-constant/next-dtype/types';
import { DTypeFormFieldComponent } from '../../dtype-field.model';

@Component({
    selector: 'codebar-scanner-field-component',
    templateUrl: './codebar-scanner-field.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class DtypeCodebarScannerFieldComponent implements DTypeFormFieldComponent, OnInit {

    @Input() field: DTypeFormCodebarScannerField;
    @Input() isUpdate: boolean;
    @Input() useSummaryView: boolean;


    constructor() { }

    ngOnInit() {
        const readonlyOnUpdate = (this.field.dTypeCol as DTypeViewableCol).readonlyOnUpdate;
        if (readonlyOnUpdate && this.isUpdate) {
            this.field.readonly = true;
        }
    }

}
